<template>
  <div class="main products feature">
    <div class="bannerBackground">
      <div class="banner">
        <p class="title">{{ $t('f-title') }}</p>
      </div>
    </div>
    <div class="mainContent">
      <div class="feature-part key-features">
        <div class="feature-info">
          <p class="feature-title title">{{ $t('feature-title') }}</p>
        </div>
        <div class="feature-intro key-feature-intro">
          <ul class="key-feature-lists">
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_chat@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list1-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list1-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_voicecalls@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list2-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list2-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_conferencecall@2x.png" alt="">
              </div>
              <!--<div class="feature-title title">Audio Auto-Spotlight in group conference call</div>-->
              <div class="feature-title title">{{ $t('feature-list3-title') }}</div>
              <!--<div class="feature-intro-detail">Enjoy end-to-end encrypted conference calls with 10 users. The audio spotlight feature amplifies the main speaker's voice, along with auto noise cancellation function. </div>-->
              <div class="feature-intro-detail">{{ $t('feature-list3-detail') }}</div>
            </li>
          </ul>
          <ul class="key-feature-lists">
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_synced@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list4-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list4-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_vioce@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list5-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list5-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_sharing@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list6-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list6-detail') }}</div>
            </li>
          </ul>
          <ul class="key-feature-lists">
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_clouddrive@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list7-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list7-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_batchsend@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list8-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list8-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_burn@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('feature-list9-title') }}</div>
              <div class="feature-intro-detail">{{ $t('feature-list9-detail') }}</div>
            </li>
          </ul>
        </div>
        <div class="feature-info other-features">
          <p class="feature-title title">{{ $t('other-feature') }}</p>
        </div>
        <div class="feature-intro key-feature-intro">
          <ul class="key-feature-lists">
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_apps@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('other-list1-title') }}</div>
              <div class="feature-intro-detail">{{ $t('other-list1-detail') }}</div>
            </li>
            <li>
              <div class="feature-img">
                <img src="../../assets/images/20180102/keyfeature_search@2x.png" alt="">
              </div>
              <div class="feature-title title">{{ $t('other-list2-title') }}</div>
              <div class="feature-intro-detail">{{ $t('other-list2-detail') }}</div>
            </li>
            <li></li>
          </ul>
        </div>
      </div>
      <!-- <div class="feature-compare">
        <div class="feature-compare-title title">Crait pro compared with normal version</div>
        <el-table
          :data="tableData"
          style="width: 100%" header-row-class-name="table-title title" cell-class-name="feature-compare-detail">
          <el-table-column
            prop="features"
            label="Features">
          </el-table-column>
          <el-table-column
            prop="crait"
            label="Crait"
            align="center">
            <template slot-scope="scope">
              <div v-show="scope.row.crait === 'Support'"><i class="el-icon-check"></i></div>
              <div v-show="scope.row.crait === 'Not Support'"><i class="el-icon-close"></i></div>
              <div v-show="scope.row.crait !== 'Support' &&  scope.row.crait !=='Not Support'">{{scope.row.crait}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="craitPro"
            label="Crait Pro"
            align="center">
            <template slot-scope="scope">
              <div v-show="scope.row.craitPro === 'Support'"><i class="el-icon-check"></i></div>
              <div v-show="scope.row.craitPro === 'Not Support'"><i class="el-icon-close"></i></div>
              <div v-show="scope.row.craitPro !== 'Support' &&  scope.row.craitPro !=='Not Support'">{{scope.row.craitPro}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div> -->
    </div>
  </div>
</template>

<script>
// import FeatureList from '../FeatureList/FeatureList'
export default {
  metaInfo () {
    return {
      title: 'Crait | ' + this.$i18n.t('features'), // set a title
      meta: [{                 // set meta
        name: 'keyWords',
        content: this.$i18n.t('key-content')
      },
      {
        name: 'description',
        content: this.$i18n.t('description-content')
      }]
    }
  },
  name: 'Feature',
  data () {
    return {
      // tableData: [{
      //   features: 'Max number of group allow to create',
      //   crait: 'Unlimited',
      //   craitPro: 'Unlimited'
      // }, {
      //   features: 'Max number of group members',
      //   crait: '20',
      //   craitPro: 'Unlimited'
      // }, {
      //   features: 'Max number of Batch Send recipients',
      //   crait: '20',
      //   craitPro: 'Unlimited'
      // }, {
      //   features: 'Max number of conference members',
      //   crait: '3',
      //   craitPro: '10'
      // }, {
      //   features: 'Cloud space for group',
      //   crait: 'Not Support',
      //   craitPro: '200MB'
      // }, {
      //   features: 'Cloud space for personal',
      //   crait: '100MB',
      //   craitPro: '1GB'
      // }, {
      //   features: 'Video call',
      //   crait: 'Support',
      //   craitPro: 'Support'
      // }, {
      //   features: 'Plug-in List',
      //   crait: 'Only server demos',
      //   craitPro: 'Charged for each plug-in'
      // }, {
      //   features: 'Customer service and technical support',
      //   crait: 'In App Support',
      //   craitPro: '7x24h (mail or telephone)'
      // }, {
      //   features: 'Provides Team Manager website or app',
      //   crait: 'Not Support',
      //   craitPro: 'Support'
      // }, {
      //   features: 'Supports all platforms',
      //   crait: 'Support',
      //   craitPro: 'Support'
      // }]
    }
  },
  components: {
//    FeatureList
  },
  created () {
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
  },
  methods: {
    test (row, cloum, cell) {
//      console.log(row)
//      console.log(cloum)
      return cell
    }
  }
}
</script>

<style lang="scss">
  .feature {
    text-align: center;
    .cur {
      cursor: pointer;
    }
    .decoration {
      text-decoration: none
    }
    .title {
      color: #323232 !important;
      font-weight: 400 !important;
    }
    .bannerBackground {
      margin-top: 1.5rem;
      @media screen and (max-width: 760px){
        margin-top: 1rem;
      }
      .banner {
        p {
          font-size: 0.5rem;
          width: 87vw;
          margin: 0.5rem auto 0.3rem;
          line-height: 0.7rem;
          @media screen and (min-width: 760px) and (max-width: 1440px) {
            width: 94vw;
          }
          @media screen and (max-width: 760px){
            width: 90vw;
            font-size: 0.23rem;
            line-height: 0.35rem;
            font-weight: 700 !important;
          }
        }
      }
    }
    //中部
    .mainContent{
      width: 100%;
      background: #fff;
      .key-features {
        .feature-intro {
          .key-feature-lists {
            display: flex;
            -ms-box-orient: horizontal;
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -moz-flex;
            display: -webkit-flex;
            li {
              -webkit-box-flex: 1;      /* OLD - iOS 6-, Safari 3.1-6 */
              -moz-box-flex: 1;         /* OLD - Firefox 19- */
              /* width: 20%; */         /* For old syntax, otherwise collapses. */
              /* 见本文底部评论@Lawrence */
              -webkit-flex: 1;          /* Chrome */
              -ms-flex: 1;              /* IE 10 */
              flex: 1;                  /* NEW, Spec - Opera 12.1, Firefox 20+ */
              margin: 0.5rem 0;
              .feature-img {
                width: 1rem;
                height: 1rem;
                /*background: #E5F0FC;*/
                margin: 0 auto 0.1rem;
                img {
                  width: 1rem;
                  max-width: 100%;
                  height: 1rem;
                  max-height: 100%;
                }
              }
              .feature-title {
                font-size: 0.3rem;
                width: 3rem;
                margin: 0 auto;
                @media screen and (max-width: 760px){
                  font-size: 0.2rem;
                }
              }
            }
          }
        }
        .key-feature-intro {
          margin: 0.5rem auto 0;
          padding: 0 2.3rem;
          @media screen and (min-width: 760px) and (max-width: 1440px) {
            padding: 0;
          }
          @media screen and (max-width: 760px){
            padding: 0;
          }
        }
      }
      .feature-part {
        padding: 0.7rem 0 0;
        text-align: center;
      }
      .feature-info {
        width: 70%;
        margin: 0 auto;
      }
      .other-features {
        margin: 0.5rem auto 0;
      }
      .feature-profile {
        font-size: 0.18rem;
        /*color: #888;*/
        margin: 0.25rem auto 0;
        width: 78%;
      }
      .feature-title {
        font-size: 0.5rem;
        /*color: #303030;*/
        font-weight: 600;
      }
      .feature-intro {
        i {
          display: inline-block;
        }
        .feature-intro-title {
          font-size: 0.4rem;
          width: 57%;
          line-height: 0.6rem;
        }
        .feature-intro-detail {
          width: 67%;
          font-size: 0.3rem;
          color: #888;
          margin: 0.2rem auto;
          line-height: 0.42rem;
          text-align: left;
          @media screen and (min-width: 760px) and (max-width: 1440px) {
            width: 85%;
          }
          @media screen and (max-width: 760px) {
            width: 88%;
          }
        }
      }
      .feature-compare {
        padding: 0 3rem;
        @media screen and (min-width: 760px) and (max-width: 1440px) {
          padding: 0 .2rem;
        }
        @media screen and (max-width: 760px) {
          padding: 0 .1rem;
        }
        .feature-compare-title {
          font-size: 0.4rem;
          text-align: center;
          @media screen and (max-width: 760px) {
            font-size: .3rem;
          }
        }
        .table-title {
          font-size: 0.3rem;
          @media screen and (max-width: 760px) {
            font-size: .2rem;
          }
        }
        .feature-compare-detail{
          font-size: 0.2rem;
          color: #666;
          @media screen and (max-width: 760px) {
            font-size: .17rem;
          }
          .cell {
            line-height: 30px;
            .el-icon-close {
              color: #e7345e;
              font-weight: bold;
            }
            .el-icon-check {
              color: #5795e2;
              font-weight: bold;
            }
          }
        }
      }
      .feature-contact-us {
        width: 3.4rem;
        height: 0.6rem;
        background: #00a3d8;
        color: #fff;
        position: absolute;
        left: 50%;
        margin-left: -1.7rem;
        font-size: 0.3rem;
        line-height: 0.6rem;
      }
      .feature-sign-up {
        display: block;
        width: 3.4rem;
        height: 0.6rem;
        background: #069c34;
        color: #fff;
        font-size: 0.3rem;
        line-height: 0.6rem;
        margin: 0.3rem auto;
      }
      /*.feature-part:nth-of-type(odd) {*/
        /*background: #fafafa;*/
      /*}*/
      @media screen and (max-width: 760px){
        .feature-part {
          padding: 0.3rem 0;
          .feature-info {
            width: 95%;
            margin-bottom: 0.5rem;
            .feature-title {
              font-size: 0.2rem;
            }
          }
          .feature-intro {
            /*display: block;*/
            flex-direction: column-reverse;
            .tool-pic {
              padding: 0;
            }
            .feature-intro-title {
              font-size: 0.2rem;
              width: 100%;
              line-height: 0.3rem;
            }
            .feature-intro-detail {
              font-size: 0.16rem;
              /*width: 95%;*/
              line-height: 0.24rem;
            }
            .feature-crait-advantage-intro, .secureCommunication {
              margin-left: 0.2rem;
              padding: 0;
            }
            .organization .feature-intro-title {
              width: 100%;
            }
            .key-feature-lists {
              display: block;
            }
          }
          .feature-intro:nth-of-type(3) {
            flex-direction: column;
          }
        }
        .download {
          .feature-info {
            margin-bottom: 0;
          }
        }
      }
      .feature-contact-us {
        width: 2.5rem;
        height: 0.4rem;
        line-height: 0.4rem;
        margin-left: -1.25rem;
        font-size: 0.2rem;
      }
      .feature-sign-up {
        width: 2.5rem;
        height: 0.4rem;
        line-height: 0.4rem;
        /*<!--margin-left: -1.25rem;-->*/
        font-size: 0.2rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// Feature.vue?54b2e8dc